import Trans from 'components/Trans'
import { VaultKey } from 'state/types'
import { bscTokens } from '@donaswap/tokens'

export const vaultPoolConfig = {
  [VaultKey.FlameVaultV1]: {
    name: <Trans>Auto FLAME</Trans>,
    description: <Trans>Automatic restaking</Trans>,
    autoCompoundFrequency: 5000,
    gasLimit: 380000n,
    tokenImage: {
      primarySrc: `/images/tokens/${bscTokens.flame.address}.png`,
      secondarySrc: '/images/autorenew.svg',
    },
  },
  [VaultKey.FlameVault]: {
    name: <Trans>Stake FLAME</Trans>,
    description: <Trans>Stake, Earn – And more!</Trans>,
    autoCompoundFrequency: 5000,
    gasLimit: 1100000n,
    tokenImage: {
      primarySrc: `/images/tokens/${bscTokens.flame.address}.png`,
      secondarySrc: '/images/autorenew.svg',
    },
  },
  [VaultKey.FlameFlexibleSideVault]: {
    name: <Trans>Flexible FLAME</Trans>,
    description: <Trans>Flexible staking on the side.</Trans>,
    autoCompoundFrequency: 5000,
    gasLimit: 500000n,
    tokenImage: {
      primarySrc: `/images/tokens/${bscTokens.flame.address}.png`,
      secondarySrc: '/images/autorenew.svg',
    },
  },
  [VaultKey.IfoPool]: {
    name: 'IFO FLAME',
    description: <Trans>Stake FLAME to participate in IFOs</Trans>,
    autoCompoundFrequency: 1,
    gasLimit: 500000n,
    tokenImage: {
      primarySrc: `/images/tokens/${bscTokens.flame.address}.png`,
      secondarySrc: `/images/ifo-pool-icon.svg`,
    },
  },
} as const
